import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const completePackingBag = createAction(ACTION.END_PACKING_BAG.REQUEST);

